import React from 'react';
import { OkButton } from '../../shared/components/Buttons';
import { withTranslation, useTranslation} from "react-i18next";
import {Alert} from "../../shared/components/Alert";
import {Link} from "react-router-dom";
import {generate} from "../../../routing/routes";
import Tooltip from "../../shared/components/Tooltip";
import {CancelButton, WhiteButton, Button, NoWayButton} from "../../shared/components/Buttons";

const AcceptQuotationButton = ({ disabled, noPhoneNumbers = false, onClick, hint, t }) =>
    <div>
        {noPhoneNumbers && <Alert className="mb-4" alert="warning">
            <div className="flex items-center">
                <p>{t('followup.noPhoneNumber')} « <Link to={generate('account_informations')} className="underline">{t('account_button.my_account')}</Link> ».</p>
            </div>
        </Alert>}

        <OkButton
            type="submit"
            disabled={disabled}
            className="!px-5"
            onClick={onClick}
        >
            {t('followup.accept_quotation')}
        </OkButton>
    </div>
;

export function TooLate(){
    const {t} = useTranslation();
    return <Tooltip Icon={null} content={t('followup.todayOrPast')} >
        <NoWayButton
            type="submit"
            disabled={true}
            className="!px-5"
            onClick={()=>{}}
        >
            {t('followup.accept_quotation')}
        </NoWayButton>
    </Tooltip>
}

export default withTranslation()(AcceptQuotationButton);
